import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/atlas';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-warm px-4 py-6 sm:py-8" data-id="element-39" data-mp="1hduloasc2p61">
      <div className="mx-auto max-w-3xl" data-id="element-40" data-mp="1cf9ka81chzg0">
        <h2 className="text-center text-2xl leading-none text-navy sm:text-3xl" data-id="element-41" data-mp="1cgb719rq4adk">
          Frequently Asked Questions
        </h2>

        <div className="mt-4 space-y-1.5" data-id="element-42" data-mp="2535nzwpc0rma">
          {faqs.map((faq, i) => {
          const open = openIndex === i;
          return <div key={faq.q} className="overflow-hidden rounded-lg border border-navy/10 bg-white shadow-sm" data-id="element-43" data-mp="202rgqgvk1lpb" data-mpi={i}>
                <h3 data-id="element-44" data-mp="oonq9ko6efp0">
                  <button type="button" onClick={() => setOpenIndex(open ? null : i)} aria-expanded={open} className="flex w-full items-center justify-between gap-3 px-3 py-2.5 text-left transition-colors duration-150 hover:bg-ice/40" data-id="element-45" data-mp="op5rywtlxm4b">
                    <span className="font-sans text-sm font-bold normal-case tracking-normal text-navy sm:text-base" data-id="element-46" data-mp="1pm1rdpfj1mj2">
                      {faq.q}
                    </span>
                    <PlusIcon className={`h-4 w-4 shrink-0 text-teal transition-transform duration-200 ease-soft ${open ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-47" data-mp="1fnc93vjpy02a" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-48" data-mp="s0w1qv3d10tp">
                  {open && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-49" data-mp="wyxl7h4p725p">
                      <p className="px-3 pb-3 text-sm font-medium leading-snug text-slate2" data-id="element-50" data-mp="2kw6pg6x700b5">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}